// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "description__header-1zQlY";
var _5 = "header__cell-1_PT8";
var _6 = "arrowIcon-23K-k";
var _7 = "title-UDBJM";
var _8 = "titleBig-p91e9";
var _9 = "titleMuted-1umBr";
var _a = "titleSecondary-dlCZo";
var _b = "titleSecondaryMuted-3t1Wm";
var _c = "text-2-u9b";
var _d = "textBrand-3xJTx";
var _e = "textAccented-3qpNc";
var _f = "textSmallAccented-3Ga3c";
var _10 = "textSmall-8NhjP";
var _11 = "toolbarRoot-3nFbJ";
var _12 = "checkbox__label-3FPau";
var _13 = "summaryFlight__features__items-JtbBX";
var _14 = "contacts__description__content-2h_q2";
var _15 = "contacts__description__text-3ljlZ";
var _16 = "contactsForm-1d-DY";
var _17 = "decrease-3juHL";
var _18 = "increase-2Xf8-";
var _19 = "counter-2cOlD";
var _1a = "contactsHeader-4RCNp";
var _1b = "description__text-3k90m";
var _1c = "description__content-1P2IZ";
var _1d = "contactsDescription-1m_V6";
var _1e = "contactsCheckbox-ge2jn";
var _1f = "passengerForm__header-19gj2";
var _20 = "passengerForm__payload-1FusB";
var _21 = "passengerForm__passengerName-K6z22";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "description__header", _5 as "header__cell", _6 as "arrowIcon", _7 as "title", _8 as "titleBig", _9 as "titleMuted", _a as "titleSecondary", _b as "titleSecondaryMuted", _c as "text", _d as "textBrand", _e as "textAccented", _f as "textSmallAccented", _10 as "textSmall", _11 as "toolbarRoot", _12 as "checkbox__label", _13 as "summaryFlight__features__items", _14 as "contacts__description__content", _15 as "contacts__description__text", _16 as "contactsForm", _17 as "decrease", _18 as "increase", _19 as "counter", _1a as "contactsHeader", _1b as "description__text", _1c as "description__content", _1d as "contactsDescription", _1e as "contactsCheckbox", _1f as "passengerForm__header", _20 as "passengerForm__payload", _21 as "passengerForm__passengerName" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "description__header": _4, "header__cell": _5, "arrowIcon": _6, "title": _7, "titleBig": _8, "titleMuted": _9, "titleSecondary": _a, "titleSecondaryMuted": _b, "text": _c, "textBrand": _d, "textAccented": _e, "textSmallAccented": _f, "textSmall": _10, "toolbarRoot": _11, "checkbox__label": _12, "summaryFlight__features__items": _13, "contacts__description__content": _14, "contacts__description__text": _15, "contactsForm": _16, "decrease": _17, "increase": _18, "counter": _19, "contactsHeader": _1a, "description__text": _1b, "description__content": _1c, "contactsDescription": _1d, "contactsCheckbox": _1e, "passengerForm__header": _1f, "passengerForm__payload": _20, "passengerForm__passengerName": _21 }
